import React from 'react';
import { Tooltip, Zoom } from '@mui/material';

export default function CustomTooltip({ children = <div></div>, title = '-' }) {
    return <Tooltip arrow children={children} title={title} TransitionComponent={Zoom} />;
}
